export default {
  namespaced: true,
  state: {
    root: true,

    // renders the screen for this route
    actions: {
      component: 'Cards.Home'
    }
  }
}
